import React, { useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { InputText } from 'primereact/inputtext'
import { Password } from 'primereact/password'
import { Button } from 'primereact/button'
import { Message } from 'primereact/message'
import { classNames } from 'primereact/utils'

import { i18n as i18nUtils } from '../../components'

import { getFormValidationErrorMessage } from './utils'


function LoginWidget(props) {

  const { auth, history, redirect, core, dispatch, actions, record, onShowRegistration, onShowPasswordReset } = props;
  const { siteConfig } = core;

  const componentCfg = record.config_json || {};
  
  // Redux actions
  const { login_post, login_clear_error, logout } = actions;

  const defaultLoginValues = {
    username: '',
    password: ''
  }

  const { control, formState: { errors }, trigger, getValues, setValue, handleSubmit } = useForm({ defaultLoginValues });

  useEffect(() => {
    dispatch(login_clear_error());
  }, []);
  
  if (auth?.data?.token) {
    const { username } = auth.data;
    return (
      <div>
        <p>{i18nUtils.translateValue("hello_user", "Olá {{username}}", undefined, undefined, undefined, {username})}.</p>
        <p>
          {i18nUtils.translateValue("clickTo", "Clique para")}
          <Button
            className="p-button-link" onClick={e => dispatch(logout())}
            label={i18nUtils.translateValue("endSession", "Terminar sessão")}
          />.
        </p>
      </div>
    )
  }

  const checkKeyDown =  async (e) => {
    if (e.code === 'Enter') {
      e.preventDefault();
      const result = await trigger(["username", "password"]);
      if (result) {
        onSubmit(getValues());
      }
    }
  };

  const onSubmit = (data) => {
    if (record?.config_json?.actions?.login) {
      core.pubsub.publish(record?.config_json?.actions?.login, null);
      return;
    }
    const apiUrl = siteConfig?.authentication?.endpoints?.login;
    dispatch(login_post(core, { username: data.username, password: data.password }, apiUrl, history, redirect));
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
      <div className="p-fluid">
        <div className="field grid">
          <label htmlFor="username" className="col-12 md:col-4">{`${i18nUtils.translateValue("user", "Utilizador")} / E-mail`}</label>
          <div className="col-12 md:col-8">
            <Controller name="username" control={control} rules={{ required: i18nUtils.translateValue("required", "Preenchimento obrigatório") }} render={({ field, fieldState }) => (
                <InputText id={field.name} {...field} autoFocus className={classNames({ 'p-invalid': fieldState.invalid })}
                  autoComplete="off"
                  aria-autocomplete="none"
                  onKeyPress={checkKeyDown} />
              )} />
            {getFormValidationErrorMessage(errors, 'username')}
          </div>
        </div>
        <div className="field grid">
          <label htmlFor="password" className="col-12 md:col-4">{i18nUtils.translateValue("password", "Palavra-passe")}</label>
          <div className="col-12 md:col-8">
            <Controller name="password" control={control} rules={{ required: i18nUtils.translateValue("required", "Preenchimento obrigatório") }} render={({ field, fieldState }) => (
              <Password id={field.name} {...field} 
                toggleMask 
                feedback={false} 
                className={classNames({ 'p-invalid': fieldState.invalid })}
                autoComplete="off"
                aria-autocomplete="none"
                onKeyPress={checkKeyDown} />                  
                )} />
            {getFormValidationErrorMessage(errors, 'password')}
          </div>
        </div>

        { (componentCfg.reset_password === true || componentCfg.reset_password_login_error === true || componentCfg.user_registration) && <div className="field grid">
          { (componentCfg.reset_password || (componentCfg.reset_password_login_error && auth.response && !!auth.response && !!auth.response.message)) && <div className={`col p-2`}>
            <Button
              className="p-button-link"
              label={i18nUtils.translateValue("passwordReset", "Recuperar password")}
              onClick={ (e) => { e.preventDefault(); onShowPasswordReset() }}
            />
          </div> }
          { componentCfg.user_registration && <div className='col p-2'>
            <Button
              className="p-button-link"
              label={i18nUtils.translateValue("userRegistration", "Novo utilizador")}
              onClick={ (e) => { e.preventDefault(); onShowRegistration() }}
            />
          </div> }          
        </div> }
      </div>

      <div className="p-dialog-myfooter">
        <Button
          type="submit" 
          color='green'
          icon={ auth.loading ? "pi pi-spin pi-spinner": "pi pi-check" }
          label={i18nUtils.translateValue("login", "Entrar")}
          disabled={auth.loading}
        />
      </div>
      
      { auth.http_error && !auth.response &&
        <div className="p-fluid">
          <Message severity="error" text={i18nUtils.translateValue("unavailableService", "Serviço indisponível")}></Message>
        </div>
      }

      { auth.response && !!auth.response && !!auth.response.message &&
        <div className="p-fluid">
          <Message severity="error" text={auth?.response?.message}></Message>
        </div>
      }

    </form>
  )
}

export default LoginWidget;